<div class="sidebar-content">
    <div class="sidebar-category sidebar-category-visible">
        <div class="category-content no-padding">
            <a class="oc-sidebar-counter" (click)="filterStatus('Active')">
                <div class="oc-sidebar-counter-active">
                    <span class="counter">{{ counterActive }}</span><br>
                    <label for="counter">Active</label>
                </div>
            </a>
            <a class="oc-sidebar-counter" (click)="filterStatus('Idle')">
                <div class="oc-sidebar-counter-idle">
                    <span class="counter">{{ counterIdle }}</span><br>
                    <label for="counter">Idle</label>
                </div>
            </a>
            <a class="oc-sidebar-counter" (click)="filterStatus('Stop')">
                <div class="oc-sidebar-counter-stop">
                    <span class="counter">{{ counterStop }}</span><br>
                    <label for="counter">Stop</label>
                </div>
            </a>
        </div>
    </div>
</div>